module.exports = __webpack_public_path__ + "img/2d-h17.e753eb10.gif";